<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/EmployeeTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)"
		class="custom-dialog __form-password"
		:title="$t(this.contractId === undefined ? 'AddNewContract' : 'UpdateContract')"
		:visible.sync="isSidebarActiveLocal"
	>
		<PerfectScrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- NAME -->
				<div class="mb-5">
					<label for class="vs-input--label">
						{{ $t("FullName") }}
						<span class="text-danger">*</span>:
					</label>
					<vs-input disabled :data-vv-as="$t('FullName')" :placeholder="`${$t('Actions.Input')} ${$t('FullName')}`" v-model="dataName" class="w-full" name="name" v-validate="'required'" />
					<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>
				</div>
				<!-- Contract type -->
				<div class="mb-5">
					<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("ContractType") }}<span class="text-danger">*</span>:</legend>
					<v-select
						ref="selectRequestTypeRef"
						:clearable="false"
						class="border-none w-full"
						:placeholder="`${$t('Actions.Choose')} ${$t('ContractType').toLowerCase()}`"
						:data-vv-as="$t('ContractType')"
						v-model="contractType"
						name="contractType"
						:options="optionsContractType"
						v-validate="'required'"
						label="name"
						@search:focus="handleOnFocusContractTypeSelect"
					>
					</v-select>
					<span class="text-danger text-sm" v-show="errors.has('contractType')">{{ errors.first("contractType") }}</span>
				</div>
				<!-- CONTRACT CODE -->
				<label for class="vs-input--label">
					{{ $t("ContractCode") }}
					<span class="text-danger">*</span>:
				</label>
				<vs-input :data-vv-as="$t('ContractCode')" :placeholder="`${$t('Actions.Input')} ${$t('ContractCode')}`" v-model="dataCode" class=" w-full" name="code" v-validate="'required'" />
				<span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first("code") }}</span>

				<!-- StartDate -->
				<div class="grid grid-cols-2 gap-4 mt-5">
					<div class="birthDate">
						<label for class="vs-input--label">{{ $t("StartDate") }}<span class="text-danger">*</span>:</label>
						<vx-input-group>
							<template slot="append">
								<div class="append-text text-black">
									<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker"></i>
								</div>
							</template>

							<cbs-date-picker
								clearable
								name="startDate"
								class="w-full"
								prefix-icon="''"
								ref="dateTimePickerRef"
								:format="userDateFormat"
								value-format="yyyy-MM-dd"
								:placeholder="`${$t('Actions.Choose')} ${$t('StartDate').toLowerCase()}`"
								v-model="startDate"
								v-validate="'required'"
								:data-vv-as="$t('StartDate')"
							/>
						</vx-input-group>
						<span class="text-danger text-sm" v-show="errors.has('startDate')">{{ errors.first("startDate") }}</span>
					</div>
					<div class="birthDate">
						<label for class="vs-input--label">{{ $t("EndDate") }}:</label>
						<vx-input-group>
							<template slot="append">
								<div class="append-text text-black">
									<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker"></i>
								</div>
							</template>

							<cbs-date-picker
								clearable
								class="w-full"
								prefix-icon="''"
								ref="dateTimePickerRef"
								:format="userDateFormat"
								value-format="yyyy-MM-dd"
								:placeholder="`${$t('Actions.Choose')} ${$t('EndDate').toLowerCase()}`"
								v-model="endDate"
							/>
						</vx-input-group>
					</div>
					<div class="birthDate ">
						<label for class="vs-input--label">{{ $t("ContractSigningDate") }}:</label>
						<vx-input-group>
							<template slot="append">
								<div class="append-text text-black">
									<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker"></i>
								</div>
							</template>

							<cbs-date-picker
								clearable
								class="w-full"
								prefix-icon="''"
								ref="dateTimePickerRef"
								:format="userDateFormat"
								value-format="yyyy-MM-dd"
								:placeholder="`${$t('Actions.Choose')} ${$t('ContractSigningDate').toLowerCase()}`"
								v-model="contractSigningDate"
							/>
						</vx-input-group>
					</div>
					<div class="">
						<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Status") }}:</legend>
						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`${$t('Status').toLowerCase()}`"
							:data-vv-as="$t('Status')"
							v-model="status"
							name="type"
							:options="optionsStatus"
							:reduce="states => states.value"
						>
						</v-select>
					</div>
				</div>

				<!-- DEPARTMENT -->
				<div class="mt-5">
					<label for class="vs-input--label">{{ $t("Department") }}:</label>
					<v-select
						class="select-tree"
						:placeholder="`${$t('Actions.Choose')} ${$t('Department').toLowerCase()}`"
						v-model="departmentId"
						:reduce="department => department.value"
						label="text"
						name="department"
						:options="departmentChoices"
					>
						<template v-slot:option="option">
							<div :class="`flex items-center pl-${option.depth > 1 ? option.depth * 2 : option.depth}`">
								<i class="mr-2 nucleo nucleo-shape-oval-3"></i>
								{{ option.text }}
							</div>
						</template>
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
				</div>

				<!-- TITLE -->
				<div class="mt-5">
					<label for class="vs-input--label">{{ $t("Title") }}:</label>
					<v-select :placeholder="`${$t('Actions.Choose')} ${$t('Title').toLowerCase()}`" v-model="titleId" :reduce="title => title.value" label="text" name="title" :options="titleChoices">
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
				</div>
				<!-- Salary -->
				<div class="mt-5">
					<label for class="vs-input--label">{{ $t("Salary") }}:</label>
					<vx-input-group prependClasses="border border-solid border-grey border-r-0">
						<template slot="prepend">
							<div class="prepend-text text-black">
								<span>VNĐ</span>
							</div>
						</template>
						<cbs-masked-input
							dataType="int"
							class="vs-inputx vs-input--input normal w-full"
							v-model.number="salary"
							name="salary"
							:userSetting="userSettings"
							v-validate="{ min_value: 0 }"
							:data-vv-as="$t('Salary')"
							:placeholder="`${$t('Actions.InputMoney')}`"
						/>
					</vx-input-group>
					<span class="text-danger text-sm break-normal" v-show="errors.has('salary')">{{ errors.first("salary") }}</span>
				</div>
				<!-- DESCRIPTION -->
				<div class="description my-5">
					<label for class="vs-input--label">{{ $t("Description") }}:</label>
					<cbs-editor class="normal-placeholder" :placeholder="`${$t('Placeholder.InputDescription')}`" v-model="description" />
				</div>
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center flex-wrap items-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData(true)">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import { backendUserPermissions, getUserPermissions } from "@/mixins/mixins.js";
import CbsEditor from "@/components/cbs-editor/CbsEditor";
import contractGql from "@/http/requests/hr/contract";

export default {
	mixins: [getUserPermissions({ ...backendUserPermissions })],

	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			initFormData: {},
			isFormDirty: false,
			//
			contractId: null,
			dataName: "",
			dataCode: "",
			titleId: null,
			departmentId: null,
			initDepartmentId: null,
			// New

			optionsStatus: [
				{ label: "Active", value: 1 },
				{ label: "Pending", value: 0 },
				{ label: "Deleted", value: -1 }
			],
			status: -1,
			startDate: null,
			endDate: null,
			contractSigningDate: null,
			salary: null,
			description: "",
			contractType: null,
			optionsContractType: [],
			employeeId: null
		};
	},
	watch: {
		isSidebarActive(val) {
			if (!val) return;
			if (Object.entries(this.data).length === 0) {
				this.initValues();
			} else {
				let { id, description, code, department_id, title_id, contracttype, employee, start_date, end_date, salary, status, signed_at } = this.data;

				this.contractId = id;
				this.titleId = title_id;
				this.departmentId = department_id;
				this.initDepartmentId = this.departmentId;
				this.dataCode = code;
				this.dataName = employee.name;
				this.employeeId = employee.id;
				this.contractType = contracttype;
				this.salary = salary;
				this.startDate = start_date;
				this.endDate = end_date;
				this.contractSigningDate = signed_at;
				this.description = description;
				this.status = status;
			}

			this.isFormDirty = false;
			this.initFormData = {
				contractId: this.contractId,
				titleId: this.titleId,
				departmentId: this.departmentId,
				initDepartmentId: this.initDepartmentId,
				dataCode: this.dataCode,
				dataName: this.dataName,
				employeeId: this.employeeId,
				contractType: this.contractType,
				salary: this.salary,
				startDate: this.startDate,
				endDate: this.endDate,
				contractSigningDate: this.contractSigningDate,
				description: this.description,
				status: this.status
			};
		},
		computedFormData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData);
			},
			deep: true
		},
		departmentId() {
			if (this.initDepartmentId !== this.departmentId) {
				this.titleId = null;
			}
		}
	},

	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},

		departmentChoices() {
			return (this.getFormattedFlattenTreeDepartments || []).map(department => ({
				value: department.id,
				text: department.name,
				depth: department.depth
			}));
		},
		...mapGetters({
			getFormattedFlattenTreeDepartments: "departmentManagement/getFormattedFlattenTreeDepartments"
		}),
		computedFormData() {
			return {
				contractId: this.contractId,
				titleId: this.titleId,
				departmentId: this.departmentId,
				initDepartmentId: this.initDepartmentId,
				dataCode: this.dataCode,
				dataName: this.dataName,
				employeeId: this.employeeId,
				contractType: this.contractType,
				salary: this.salary,
				startDate: this.startDate,
				endDate: this.endDate,
				contractSigningDate: this.contractSigningDate,
				description: this.description,
				status: this.status
			};
		},
		titleChoices() {
			return (
				this.$store.state.titleManagement.titles
					.filter(title => {
						return title.department.id === this.departmentId;
					})
					.map(title => ({
						value: title.id,
						text: title.name
					})) || []
			);
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.contractId = null;
			this.dataName = "";
			this.dataCode = "";
			this.departmentId = null;
			this.titleId = null;
			this.tags = [];

			this.$validator.reset().then(() => {
				this.allowLogin = false;
			});
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			if (isCloseForm) {
				this.$emit("closeSidebar");
			}
			this.initValues();
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: `${this.$t(`${this.contractId ? "UpdateContract" : "AddNewContract"}`)} ${this.$t("Successful").toLowerCase()}`
				}
			});
			this.$emit("refetchDataList");
		},
		async handleCreateOrUpdateEmployee(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				if (this.contractId) {
					await contractGql.updateContract({
						...dataObj,
						id: this.contractId
					});
				} else {
					await contractGql.addContract(dataObj);
				}

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					const dataObj = {
						code: this.dataCode || "",
						start_date: this.startDate,
						end_date: this.endDate,
						signed_at: this.contractSigningDate,
						salary: this.salary,
						description: this.description,
						employee_id: this.employeeId,
						contracttype_id: this.contractType.id,
						status: this.status,
						department_id: this.departmentId,
						title_id: this.titleId
					};

					this.handleCreateOrUpdateEmployee(dataObj, isCloseForm);
				}
			});
		},
		async fetchFormOptions() {
			try {
				await Promise.all([this.$store.dispatch("departmentManagement/fetchDepartments", {}), this.$store.dispatch("titleManagement/fetchTitles", {})]);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		triggerClickDatetimePicker() {
			this.$refs.dateTimePickerRef.$children[0].pickerVisible = true;
		},
		async handleOnFocusContractTypeSelect() {
			if (this.optionsContractType.length === 0) {
				const loadingRef = this.$refs.selectRequestTypeRef && this.$refs.selectRequestTypeRef.toggleLoading;
				try {
					if (loadingRef) {
						loadingRef(true);
					}
					const response = await contractGql.contractTypes();
					console.log("HERE response", response);

					this.optionsContractType = response.contractTypes || [];
				} catch (error) {
					console.error(error);
					this.$helper.notifyError({ context: this, error });
				} finally {
					if (loadingRef) {
						loadingRef(false);
					}
				}
			}
		}
	},
	components: {
		vSelect,
		CbsEditor
	},
	created() {
		this.fetchFormOptions();
	}
};
</script>
